//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AccountCode',
  props: {
    length: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      // 验证码
      code: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.code = [];
      for (let i = 0; i < Number(this.length); i += 1) {
        this.code.push('');
      }
      const timer = setTimeout(() => {
        this.controlFocus();
        clearTimeout(timer);
      }, 10);
    },
    // focus事件和input事件都自动更新当前选中的格子
    controlFocus() {
      let aim = 'input';
      // 自动搜索第一个未填满的空格并focus
      for (let i = 0; i < this.code.length; i += 1) {
        if (this.code[i] === '') {
          aim += i.toString();
          break;
        }
      }

      // 所有空格都填满了 指向最后一个
      if (aim === 'input') {
        aim = `input${this.code.length - 1}`;
      }
      this.$refs[aim][0].focus();
    },
    // 单格 input 事件；如果用户在某一格输入了多字符（部分浏览器/输入法会短暂绕过 maxlength），走分发逻辑
    onInput(val, index) {
      if (typeof val === 'string' && val.length > 1) {
        this.distributeChars(val, index);
        return;
      }
      this.$emit('change', this.code.join(''));
      this.controlFocus();
    },
    // 粘贴事件：拦截默认粘贴，将粘贴内容分发到各格
    onPaste(e) {
      const text = (e.clipboardData || window.clipboardData)?.getData?.('text') || '';
      if (!text) return;
      e.preventDefault();
      // 取粘贴目标格子的索引（若取不到则默认从第一个空格开始）
      let startIndex = 0;
      for (let i = 0; i < this.code.length; i += 1) {
        if (this.code[i] === '') {
          startIndex = i;
          break;
        }
      }
      this.distributeChars(text, startIndex);
    },
    // 将字符串 text 从 startIndex 开始逐字符填入 code[]，自动截断超出部分
    distributeChars(text, startIndex) {
      // 仅保留可见字符，过滤掉空格、换行等（数字/字母均允许，保持通用）
      const chars = (text || '').replace(/\s+/g, '').split('');
      let cursor = startIndex;
      for (let i = 0; i < chars.length && cursor < this.code.length; i += 1) {
        this.$set(this.code, cursor, chars[i]);
        cursor += 1;
      }
      this.$emit('change', this.code.join(''));
      // 聚焦到最后一个被填充的格子（或下一个空格）
      this.$nextTick(() => {
        this.controlFocus();
        this.submitCode();
      });
    },
    deleteFocus() {
      // 已经全部填满 删除最后一个
      if (this.code[this.code.length - 1] !== '') {
        this.code[this.code.length - 1] = '';
        this.$forceUpdate();
        this.$emit('change', this.code.join(''));
        this.controlFocus();
      } else {
        // 寻找最后一个被填满的空格清空它
        for (let i = 0; i < this.code.length; i += 1) {
          if (this.code[i] === '') {
            if (i !== 0) {
              this.code[i - 1] = '';
              this.$forceUpdate();
              this.$emit('change', this.code.join(''));
              this.controlFocus();
            }
            break;
          }
        }
      }
    },
    submitCode() {
      const lengths = this.length;
      let validateNum = 0;
      for (let i = 0; i < this.code.length; i += 1) {
        if (this.code[i] !== '') {
          validateNum += 1;
        }
      }
      if (validateNum === Number(lengths)) {
        this.$emit('doSubmit');
      }
    },
  },
};
